export const FONT_OPTIONS = [
  { value: 'Century Gothic', label: 'Century Gothic' },
  { value: 'Inter', label: 'Inter' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Manrope', label: 'Manrope' },
  { value: 'Work Sans', label: 'Work Sans' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Lato', label: 'Lato' },
  { value: 'Source Sans Pro', label: 'Source Sans Pro' },
  { value: 'Source Serif Pro', label: 'Source Serif Pro' },
  { value: 'Nunito Sans', label: 'Nunito Sans' },
  { value: 'Merriweather', label: 'Merriweather' },
  { value: 'Libre Baskerville', label: 'Libre Baskerville' },
  { value: 'Playfair Display', label: 'Playfair Display' },
  { value: 'Archivo', label: 'Archivo' },
  { value: 'Fira Sans', label: 'Fira Sans' },
  { value: 'Teko', label: 'Teko' },
  { value: 'Bebas Neue', label: 'Bebas Neue' },
  { value: 'DM Sans', label: 'DM Sans' },
  { value: 'Hind', label: 'Hind' },
  { value: 'Oswald', label: 'Oswald' },
  { value: 'Allura', label: 'Allura' },
  { value: 'Alex Brush', label: 'Alex Brush' },
  { value: 'Arizonia', label: 'Arizonia' },
  { value: 'Berkshire Swash', label: 'Berkshire Swash' },
  { value: 'Charm', label: 'Charm' },
  { value: 'Chewy', label: 'Chewy' },
  { value: 'Delius', label: 'Delius' },
  { value: 'Delius Swash Caps', label: 'Delius Swash Caps' },
  { value: 'Dorsa', label: 'Dorsa' },
  { value: 'Engagement', label: 'Engagement' },
  { value: 'Flamenco', label: 'Flamenco' },
  { value: 'Flavors', label: 'Flavors' },
  { value: 'Fondamento', label: 'Fondamento' },
  { value: 'Imbue', label: 'Imbue' },
  { value: 'Italianno', label: 'Italianno' },
  { value: 'Jomhuria', label: 'Jomhuria' },
  { value: 'Julee', label: 'Julee' },
  { value: 'Knewave', label: 'Knewave' },
  { value: 'Lancelot', label: 'Lancelot' },
  { value: 'Lemonada', label: 'Lemonada' },
  { value: 'MedievalSharp', label: 'MedievalSharp' },
  { value: 'Megrim', label: 'Megrim' },
  { value: 'Neucha', label: 'Neucha' },
  { value: 'Rancho', label: 'Rancho' },
  { value: 'Ribeye', label: 'Ribeye' },
  { value: 'Ruthie', label: 'Ruthie' },
  { value: 'Sacramento', label: 'Sacramento' },
  { value: 'Sarina', label: 'Sarina' },
  { value: 'Sail', label: 'Sail' },
  { value: 'Schoolbell', label: 'Schoolbell' },
  { value: 'Sunshiney', label: 'Sunshiney' },
  { value: 'Tangerine', label: 'Tangerine' },
  { value: 'Unkempt', label: 'Unkempt' },
  { value: 'Yesteryear', label: 'Yesteryear' },
  { value: 'Zeyada', label: 'Zeyada' },
];

export const FONT_SIZE_OPTIONS = [
  8, 9, 10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 28, 32, 36, 40, 48, 56, 64, 72, 80, 96,
];

export const deepClone = (value) => JSON.parse(JSON.stringify(value));

const createCanvas = (orientation = 'landscape', overrides = {}) => {
  if (orientation === 'portrait') {
    return {
      width: 1080,
      height: 1920,
      orientation: 'portrait',
      background: '#0f172a',
      ...overrides,
    };
  }
  return {
    width: 1920,
    height: 1080,
    orientation: 'landscape',
    background: '#0f172a',
    ...overrides,
  };
};

const createPosition = (overrides = {}) => ({
  x: 0,
  y: 0,
  width: 400,
  height: 160,
  ...overrides,
});

const createTextElement = (id, binding, overrides = {}) => ({
  id,
  type: 'text',
  binding,
  position: createPosition(overrides.position),
  style: {
    fontFamily: 'Inter',
    fontSize: 64,
    fontWeight: 600,
    color: '#f8fafc',
    align: 'left',
    lineHeight: 1.1,
    ...overrides.style,
  },
});

const createImageElement = (overrides = {}) => ({
  id: overrides.id || 'image',
  type: 'image',
  binding: 'image',
  position: createPosition({ width: 720, height: 720, ...overrides.position }),
  style: {
    borderRadius: 36,
    shadow: true,
    ...overrides.style,
  },
});

const QR_LABEL_DEFAULT = '';

const createQrElement = (overrides = {}) => ({
  id: overrides.id || 'qr',
  type: 'qr',
  binding: 'qr',
  position: createPosition({ width: 260, height: 260, ...overrides.position }),
  style: {
    background: 'rgba(15,23,42,0.8)',
    borderRadius: 16,
    ...overrides.style,
  },
});

const createQrLabelElement = (overrides = {}) =>
  createTextElement(overrides.id || 'qrLabel', 'qrLabel', {
    position: createPosition({
      width: 260,
      height: 100,
      ...overrides.position,
    }),
    style: {
      fontSize: 24,
      fontWeight: 600,
      align: 'center',
      color: '#f8fafc',
      defaultText: QR_LABEL_DEFAULT,
      ...overrides.style,
    },
  });

export const DEFAULT_TEMPLATES = {
  'classic-right': {
    canvas: createCanvas('landscape', {
      gradientColorA: '#0d2d4f',
      gradientColorB: '#1c1154',
      gradientDirection: '135deg',
      backgroundImage: 'linear-gradient(135deg, #0d2d4f, #1c1154)',
    }),
    elements: [
      createTextElement('title', 'title', {
        position: { x: 80, y: 80, width: 960, height: 190 },
        style: {
          fontFamily: 'Playfair Display',
          fontSize: 96,
          fontWeight: 700,
          color: '#f8fafc',
          lineHeight: 1.05,
        },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 80, y: 292, width: 960, height: 100 },
        style: {
          fontFamily: 'Manrope',
          fontSize: 44,
          fontWeight: 600,
          color: '#38bdf8',
          lineHeight: 1.1,
        },
      }),
      createTextElement('message', 'message', {
        position: { x: 80, y: 420, width: 960, height: 580 },
        style: {
          fontFamily: 'DM Sans',
          fontSize: 32,
          fontWeight: 400,
          lineHeight: 1.5,
          color: '#e2e8f0',
        },
      }),
      createImageElement({
        position: { x: 1068, y: 40, width: 800, height: 700 },
        style: { borderRadius: 40, shadow: true },
      }),
      createQrElement({
        position: { x: 1380, y: 790, width: 240, height: 240 },
        style: { borderRadius: 16, showLabel: false },
      }),
    ],
  },
  'classic-left': {
    canvas: createCanvas('landscape', {
      background: '#0c1120',
      gradientColorA: '#2d1b00',
      gradientColorB: '#1c1154',
      gradientDirection: '135deg',
      backgroundImage: 'linear-gradient(135deg, #2d1b00, #1c1154)',
    }),
    elements: [
      createImageElement({ position: { x: 120, y: 160, width: 720, height: 720 }, style: { borderRadius: 52 } }),
      createTextElement('title', 'title', {
        position: { x: 900, y: 160, width: 840, height: 160 },
        style: { fontFamily: 'Playfair Display', fontSize: 88, fontWeight: 700, color: '#f8fafc' },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 900, y: 340, width: 840, height: 120 },
        style: { fontFamily: 'Manrope', fontSize: 44, color: '#fbbf24' },
      }),
      createTextElement('message', 'message', {
        position: { x: 900, y: 480, width: 840, height: 360 },
        style: { fontFamily: 'Source Sans Pro', fontSize: 30, lineHeight: 1.4, color: '#e2e8f0' },
      }),
      createTextElement('footer', 'footer', {
        position: { x: 900, y: 860, width: 520, height: 90 },
        style: { fontSize: 24, letterSpacing: 6, color: '#cbd5f5', textTransform: 'uppercase' },
      }),
      createQrElement({ position: { x: 1420, y: 840, width: 260, height: 260 }, style: { label: 'Point your camera', background: 'rgba(15,23,42,0.85)' } }),
      createQrLabelElement({ position: { x: 1420, y: 1120, width: 260, height: 96 } }),
    ],
  },
  'showcase-banner': {
    canvas: createCanvas('landscape', {
      background: '#080d1a',
      gradientColorA: '#0a1f38',
      gradientColorB: '#0a0e1f',
      gradientDirection: '180deg',
      backgroundImage: 'linear-gradient(180deg, #0a1f38, #0a0e1f)',
    }),
    elements: [
      createTextElement('title', 'title', {
        position: { x: 160, y: 160, width: 1600, height: 160 },
        style: { fontFamily: 'Bebas Neue', fontSize: 120, align: 'center' },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 160, y: 340, width: 1600, height: 120 },
        style: { fontFamily: 'Work Sans', fontSize: 48, align: 'center', color: '#38bdf8' },
      }),
      createTextElement('message', 'message', {
        position: { x: 160, y: 480, width: 1600, height: 260 },
        style: { fontFamily: 'DM Sans', fontSize: 34, align: 'center', lineHeight: 1.4, color: '#e2e8f0' },
      }),
      createImageElement({ position: { x: 160, y: 760, width: 1600, height: 520 }, style: { borderRadius: 40 } }),
      createQrElement({ position: { x: 1460, y: 1320, width: 260, height: 260 }, style: { label: 'Scan for the full story', align: 'center' } }),
      createQrLabelElement({ position: { x: 1460, y: 1600, width: 260, height: 96 }, style: { align: 'center' } }),
      createTextElement('footer', 'footer', {
        position: { x: 160, y: 1320, width: 1220, height: 90 },
        style: { fontSize: 26, align: 'left', color: '#94a3b8', textTransform: 'uppercase' },
      }),
    ],
  },
  'spotlight-card': {
    canvas: createCanvas('landscape', { background: '#111827' }),
    elements: [
      createImageElement({ position: { x: 0, y: 0, width: 1920, height: 1080 }, style: { borderRadius: 0, shadow: false } }),
      createTextElement('title', 'title', {
        position: { x: 180, y: 220, width: 820, height: 140 },
        style: { fontFamily: 'Oswald', fontSize: 96, color: '#f8fafc' },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 180, y: 380, width: 820, height: 120 },
        style: { fontFamily: 'Manrope', fontSize: 48, color: '#facc15' },
      }),
      createTextElement('message', 'message', {
        position: { x: 180, y: 520, width: 820, height: 360 },
        style: { fontFamily: 'Nunito Sans', fontSize: 32, color: '#f1f5f9', lineHeight: 1.45 },
      }),
      createTextElement('footer', 'footer', {
        position: { x: 180, y: 900, width: 500, height: 80 },
        style: { fontSize: 24, color: '#cbd5f5', textTransform: 'uppercase', letterSpacing: 6 },
      }),
      createQrElement({ position: { x: 1480, y: 760, width: 280, height: 280 }, style: { label: 'Scan for exclusive access', background: 'rgba(15,23,42,0.85)' } }),
      createQrLabelElement({ position: { x: 1480, y: 1060, width: 280, height: 96 } }),
    ],
  },
  'bold-center': {
    canvas: createCanvas('landscape', {
      background: '#0c111e',
      gradientColorA: '#0a1f38',
      gradientColorB: '#180a38',
      gradientDirection: '135deg',
      backgroundImage: 'linear-gradient(135deg, #0a1f38, #180a38)',
    }),
    elements: [
      createTextElement('title', 'title', {
        position: { x: 190, y: 200, width: 900, height: 200 },
        style: { fontFamily: 'Teko', fontSize: 132, align: 'center', color: '#f8fafc' },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 190, y: 420, width: 900, height: 120 },
        style: { fontFamily: 'Roboto', fontSize: 48, align: 'center', color: '#38bdf8' },
      }),
      createTextElement('message', 'message', {
        position: { x: 190, y: 560, width: 900, height: 260 },
        style: { fontFamily: 'Source Sans Pro', fontSize: 34, align: 'center', color: '#e2e8f0', lineHeight: 1.4 },
      }),
      createTextElement('footer', 'footer', {
        position: { x: 190, y: 840, width: 900, height: 80 },
        style: { fontFamily: 'Hind', fontSize: 28, align: 'center', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 6 },
      }),
      createImageElement({ position: { x: 1180, y: 220, width: 520, height: 520 }, style: { borderRadius: 32 } }),
      createQrElement({ position: { x: 1280, y: 780, width: 240, height: 240 }, style: { label: 'Scan to RSVP now', background: 'rgba(17,24,39,0.9)' } }),
      createQrLabelElement({ position: { x: 1280, y: 1040, width: 240, height: 96 } }),
    ],
  },
  'portrait-showcase': {
    canvas: createCanvas('portrait', {
      background: '#080d1a',
      gradientColorA: '#0a1f38',
      gradientColorB: '#080d1a',
      gradientDirection: 'to bottom',
      backgroundImage: 'linear-gradient(to bottom, #0a1f38, #080d1a)',
    }),
    elements: [
      createTextElement('title', 'title', {
        position: { x: 140, y: 140, width: 800, height: 180 },
        style: { fontFamily: 'Bebas Neue', fontSize: 120, align: 'center' },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 140, y: 340, width: 800, height: 120 },
        style: { fontFamily: 'Work Sans', fontSize: 44, align: 'center', color: '#38bdf8' },
      }),
      createImageElement({ position: { x: 120, y: 500, width: 840, height: 760 }, style: { borderRadius: 48 } }),
      createTextElement('message', 'message', {
        position: { x: 140, y: 1300, width: 800, height: 320 },
        style: { fontFamily: 'DM Sans', fontSize: 36, align: 'center', color: '#e2e8f0', lineHeight: 1.4 },
      }),
      createTextElement('footer', 'footer', {
        position: { x: 140, y: 1640, width: 800, height: 80 },
        style: { fontSize: 28, align: 'center', textTransform: 'uppercase', letterSpacing: 6, color: '#cbd5f5' },
      }),
      createQrElement({ position: { x: 360, y: 1740, width: 360, height: 360 }, style: { label: 'Scan for the full story', background: 'rgba(15,23,42,0.85)' } }),
      createQrLabelElement({ position: { x: 360, y: 2120, width: 360, height: 96 } }),
    ],
  },
  'portrait-spotlight': {
    canvas: createCanvas('portrait', { background: '#0a0d14' }),
    elements: [
      createImageElement({ position: { x: 0, y: 0, width: 1080, height: 1920 }, style: { borderRadius: 0, shadow: false } }),
      createTextElement('title', 'title', {
        position: { x: 140, y: 220, width: 800, height: 200 },
        style: { fontFamily: 'Oswald', fontSize: 112, align: 'center', color: '#f8fafc' },
      }),
      createTextElement('subtitle', 'subtitle', {
        position: { x: 140, y: 440, width: 800, height: 140 },
        style: { fontFamily: 'Manrope', fontSize: 48, align: 'center', color: '#facc15' },
      }),
      createTextElement('message', 'message', {
        position: { x: 140, y: 620, width: 800, height: 420 },
        style: { fontFamily: 'Nunito Sans', fontSize: 36, align: 'center', color: '#f1f5f9', lineHeight: 1.45 },
      }),
      createTextElement('footer', 'footer', {
        position: { x: 140, y: 1080, width: 800, height: 80 },
        style: { fontSize: 26, align: 'center', color: '#cbd5f5', textTransform: 'uppercase', letterSpacing: 6 },
      }),
      createQrElement({ position: { x: 360, y: 1200, width: 360, height: 360 }, style: { label: 'Scan to explore more', background: 'rgba(15,23,42,0.9)' } }),
      createQrLabelElement({ position: { x: 360, y: 1580, width: 360, height: 96 } }),
    ],
  },
  'artwork-only': {
    canvas: createCanvas('landscape', { background: '#000000' }),
    elements: [
      createImageElement({
        position: { x: 0, y: 0, width: 1920, height: 1080 },
        style: { borderRadius: 0, shadow: false, objectFit: 'contain' },
      }),
      createQrElement({
        position: { x: 1660, y: 820, width: 210, height: 210 },
        style: { borderRadius: 12, showLabel: false, background: 'rgba(0,0,0,0.55)' },
      }),
    ],
  },
};

export const ensureTvLayout = (layout = {}) => {
  const canvas = layout.canvas ? { ...createCanvas(layout.canvas.orientation || 'landscape'), ...layout.canvas } : createCanvas('landscape');
  let elements = Array.isArray(layout.elements)
    ? layout.elements.map((element, index) => ({
        id: element.id || `${element.type || 'element'}-${index}`,
        type: element.type || 'text',
        binding: element.binding || 'title',
        position: createPosition(element.position),
        style: {
          fontFamily: element.style?.fontFamily || 'Inter',
          fontSize: element.style?.fontSize || 32,
          color: element.style?.color || '#f8fafc',
          fontWeight: element.style?.fontWeight || 500,
          align: element.style?.align || 'left',
          lineHeight: element.style?.lineHeight || 1.2,
          letterSpacing: element.style?.letterSpacing,
          textTransform: element.style?.textTransform,
          background: element.style?.background,
          borderRadius: element.style?.borderRadius,
          shadow: element.style?.shadow,
          label: element.style?.label,
          defaultText: element.style?.defaultText,
          showLabel: element.style?.showLabel,
          objectFit: element.style?.objectFit,
          staticText: element.style?.staticText,
        },
      }))
    : deepClone(DEFAULT_TEMPLATES['classic-right'].elements);

  const qrElement = elements.find((element) => element.type === 'qr');
  if (qrElement) {
    let labelElement = elements.find((element) => element.type === 'text' && element.binding === 'qrLabel');
    const qrPosition = qrElement.position || {};
    const fallbackLabel = qrElement.style?.label || QR_LABEL_DEFAULT;
    const autoLabel = qrElement.style?.showLabel !== false;

    if (!labelElement && autoLabel) {
      const labelHeight = 96;
      const labelWidth = qrPosition.width || 260;
      const desiredBelow = (qrPosition.y || 0) + (qrPosition.height || 0) + 16;
      const fitsBelow = desiredBelow + labelHeight <= canvas.height;
      const labelId = qrElement.id ? `${qrElement.id}-label` : 'qrLabel';
      const computedY = fitsBelow
        ? desiredBelow
        : Math.max(0, (qrPosition.y || 0) - labelHeight - 16);
      labelElement = {
        id: labelId,
        type: 'text',
        binding: 'qrLabel',
        position: createPosition({
          x: qrPosition.x || 0,
          y: computedY,
          width: labelWidth,
          height: labelHeight,
        }),
        style: {
          fontFamily: qrElement.style?.fontFamily || 'Inter',
          fontSize: qrElement.style?.fontSize || 24,
          fontWeight: qrElement.style?.fontWeight || 600,
          color: qrElement.style?.color || '#f8fafc',
          align: 'center',
          lineHeight: 1.2,
          letterSpacing: qrElement.style?.letterSpacing,
          defaultText: fallbackLabel,
        },
      };
      elements = [...elements, labelElement];
    } else if (labelElement) {
      if (!labelElement.style) labelElement.style = {};
      if (!labelElement.style.fontFamily) labelElement.style.fontFamily = qrElement.style?.fontFamily || 'Inter';
      if (!labelElement.style.fontSize) labelElement.style.fontSize = qrElement.style?.fontSize || 24;
      if (!labelElement.style.fontWeight) labelElement.style.fontWeight = qrElement.style?.fontWeight || 600;
      if (!labelElement.style.color) labelElement.style.color = qrElement.style?.color || '#f8fafc';
      if (!labelElement.style.align) labelElement.style.align = 'center';
      if (!labelElement.style.lineHeight) labelElement.style.lineHeight = 1.2;
      if (!labelElement.style.defaultText) labelElement.style.defaultText = fallbackLabel;
    }
  }

  const ensured = {
    templateId: layout.templateId || layout.id || 'classic-right',
    templateName: layout.templateName || layout.name || 'Classic Right',
    canvas,
    elements,
  };
  if (layout.isUserTemplate) ensured.isUserTemplate = true;
  return ensured;
};

const createTemplate = (id, name, { canvas, elements }) => ({
  id,
  name,
  layout: ensureTvLayout({
    templateId: id,
    templateName: name,
    canvas,
    elements,
  }),
});

export const DEFAULT_TV_LAYOUT = ensureTvLayout({
  templateId: 'classic-right',
  templateName: 'Classic Right',
  ...DEFAULT_TEMPLATES['classic-right'],
});

const TEMPLATE_LIST = [
  createTemplate('classic-right', 'Classic Right', DEFAULT_TEMPLATES['classic-right']),
  createTemplate('classic-left', 'Classic Left', DEFAULT_TEMPLATES['classic-left']),
  createTemplate('showcase-banner', 'Showcase Banner', DEFAULT_TEMPLATES['showcase-banner']),
  createTemplate('spotlight-card', 'Spotlight Card', DEFAULT_TEMPLATES['spotlight-card']),
  createTemplate('bold-center', 'Bold Center', DEFAULT_TEMPLATES['bold-center']),
  createTemplate('portrait-showcase', 'Portrait Showcase', DEFAULT_TEMPLATES['portrait-showcase']),
  createTemplate('portrait-spotlight', 'Portrait Spotlight', DEFAULT_TEMPLATES['portrait-spotlight']),
  createTemplate('artwork-only', 'Artwork Only', DEFAULT_TEMPLATES['artwork-only']),
];

export const TV_TEMPLATES = TEMPLATE_LIST;

export const ensureLayouts = (rawLayouts = {}) => {
  const base = rawLayouts && typeof rawLayouts === 'object' ? deepClone(rawLayouts) : {};
  const templates = base.templates && typeof base.templates === 'object' ? base.templates : {};

  const normalizedTemplates = { ...DEFAULT_TEMPLATES };
  Object.entries(templates).forEach(([id, layout]) => {
    const ensured = ensureTvLayout({ ...layout, templateId: id, templateName: layout.templateName || id });
    if (layout.isUserTemplate || id.startsWith('user-')) {
      ensured.isUserTemplate = true;
    }
    normalizedTemplates[id] = ensured;
  });

  const templateId = base.tv?.templateId || 'classic-right';
  const templateLayout = normalizedTemplates[templateId] || normalizedTemplates['classic-right'];
  // Merge canvas individually so backgroundImage from the template isn't wiped by an old stored canvas
  const mergedCanvas = { ...(templateLayout?.canvas || {}), ...(base.tv?.canvas || {}) };
  const tvLayout = ensureTvLayout({ ...templateLayout, ...base.tv, canvas: mergedCanvas, templateId });

  return {
    templates: normalizedTemplates,
    tv: tvLayout,
  };
};

export const getTemplateById = (id, layouts = {}) => {
  if (!id) return ensureTvLayout(DEFAULT_TEMPLATES['classic-right']);
  const library = layouts.templates || DEFAULT_TEMPLATES;
  const source = library[id] || DEFAULT_TEMPLATES[id] || DEFAULT_TEMPLATES['classic-right'];
  return ensureTvLayout({ ...source, templateId: id, templateName: source.templateName || id });
};

export const CANVAS_GRADIENT_PRESETS = [
  { id: 'none',     label: 'None',    value: null,   swatch: null },
  { id: 'cool',     label: 'Cool',    value: 'radial-gradient(ellipse at 88% 12%, rgba(56,189,248,0.24) 0%, transparent 44%), radial-gradient(ellipse at 10% 90%, rgba(99,102,241,0.18) 0%, transparent 44%)',  swatch: ['#38bdf8', '#6366f1'] },
  { id: 'warm',     label: 'Warm',    value: 'radial-gradient(ellipse at 12% 12%, rgba(251,191,36,0.22) 0%, transparent 42%), radial-gradient(ellipse at 90% 88%, rgba(99,102,241,0.18) 0%, transparent 42%)',  swatch: ['#fbbf24', '#6366f1'] },
  { id: 'electric', label: 'Electric',value: 'radial-gradient(ellipse at 50% 0%, rgba(56,189,248,0.20) 0%, transparent 52%), radial-gradient(ellipse at 90% 90%, rgba(168,85,247,0.14) 0%, transparent 42%)',  swatch: ['#38bdf8', '#a855f7'] },
  { id: 'sunrise',  label: 'Sunrise', value: 'radial-gradient(ellipse at 80% 0%, rgba(245,158,11,0.22) 0%, transparent 46%), radial-gradient(ellipse at 15% 95%, rgba(239,68,68,0.14) 0%, transparent 46%)',   swatch: ['#f59e0b', '#ef4444'] },
  { id: 'emerald',  label: 'Emerald', value: 'radial-gradient(ellipse at 85% 15%, rgba(16,185,129,0.20) 0%, transparent 44%), radial-gradient(ellipse at 12% 85%, rgba(56,189,248,0.14) 0%, transparent 44%)', swatch: ['#10b981', '#38bdf8'] },
  { id: 'rose',     label: 'Rose',    value: 'radial-gradient(ellipse at 80% 10%, rgba(244,63,94,0.22) 0%, transparent 44%), radial-gradient(ellipse at 15% 88%, rgba(139,92,246,0.14) 0%, transparent 44%)',  swatch: ['#f43f5e', '#8b5cf6'] },
];
